import Header from "./Header/Header";
import SideBar from "./SideBar/SideBar";
import { Outlet } from "react-router-dom";
import { useHostStore } from "host/HostStore";
import React, { useLayoutEffect } from "react";
import { MantineProvider } from "@mantine/core";
import { layoutSpotlightActions } from "./Layout.data";
import { SpotlightProvider } from "@mantine/spotlight";
import { layoutInitializer } from "./Initializer/Initializer";
import { SideBarContextProvider } from "store/context/SideBarContext/SideBarContext";

type Props = {};

export default function Layout({}: Props) {
    const { auth } = useHostStore();

    useLayoutEffect(() => {
        layoutInitializer();
    }, []);

    return (
        <SideBarContextProvider>
            <MantineProvider>
                <Header auth={auth} />
                <div className="h-full flex overflow-hidden">
                    {/* <SideBar /> */}
                    <main className="h-full w-full overflow-y-scroll">
                        <Outlet />
                    </main>
                </div>
            </MantineProvider>
        </SideBarContextProvider>
    );
}
